import React from 'react'
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useMutation,
} from '@tanstack/react-query'
import { useToast } from '~/lib/ui/toast'
import { apiGet, apiPost } from '~/util/api'

export const queryClient = new QueryClient()

window.__TANSTACK_QUERY_CLIENT__ = queryClient

const pathName = `${window.location.pathname}.json`

const invalidateProfileQuery = () => {
  queryClient.invalidateQueries({ queryKey })
}

const queryFn = async () =>
  apiGet(`${window.location.pathname}.json`).then((response) => response.data)

const queryKey = ['profile']

export const useProfileQuery = () =>
  useQuery({
    queryFn,
    queryKey,
  })

export const ProfileQueryClientProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}

export const useProfileMutation = () => {
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (updatedProfile) => {
      const res = await apiPost(pathName, { profile: updatedProfile })
      return res.data
    },
    onSuccess: () => {
      invalidateProfileQuery()
      toast({ description: 'Profile updated successfully!', timeout: 3000 })
    },
    onError: (error) => {
      toast({
        description: error.message,
        title: 'Profile update failed',
        variant: 'destructive',
      })
    },
  })
}

export const usePhotoMutation = () => {
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (file) => {
      const formData = new FormData()
      formData.append('profile[photo]', file)

      const res = await apiPost(pathName, formData, true)
      return res.data
    },
    onError: (error) => {
      toast({
        description: error.message,
        title: 'Profile update failed',
        variant: 'destructive',
      })
    },
    onSuccess: () => {
      invalidateProfileQuery()
      toast({ description: 'Photo uploaded successfully!', timeout: 3000 })
    },
  })
}
